import { AxiosError } from "axios";
import { QueryClient } from "react-query";
import { useNavigate } from "react-router-dom";

const API_STALETIME = process.env.REACT_APP_API_STALETIME as number | undefined;

function useErrorHandling() {
    const navigate = useNavigate();

    const handleError = (error: any) => {
        const axiosError = error as AxiosError;
        const status = axiosError.response ? axiosError.response.status : 500;
        navigate(`error/${status}`, { state: { status } });
    };

    return handleError;
}

export const useSetupQueryClient = () => {
    const handleError = useErrorHandling();

    return new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: API_STALETIME,
                refetchOnWindowFocus: false,
                onError: handleError
            }
        }
    });
};
